import { makeStyles, Tab, TabList, Text } from "@fluentui/react-components";
import { useState } from "react";
import TitleText from "../../../components/titleText/TitleText";
import IPageTabs from "../../../models/page/pageComponents/IPageTabs";

const useStyles = makeStyles({
    container: {
        display: "flex",
        flexDirection: "column",
        padding: "0 2rem",
        maxWidth: "1200px",
        margin: "0 auto",
        alignItems: "center",
        width: "100%",
    },
    tabsWrapper: {
        width: "100%",
        marginTop: "0.5rem",
    },
    tabContent: {
        padding: "1.5rem 0.5rem",
        color: "#444444",
        fontSize: "1rem",
        lineHeight: "1.8",
        whiteSpace: "pre-wrap",
    },
});

export default function Tabs(props: IPageTabs) {
    const styles = useStyles();
    const [selectedTab, setSelectedTab] = useState<string>("tab-0");

    if (!props.tabs?.length) return null;

    const activeTab = props.tabs.find((_, i) => `tab-${i}` === selectedTab);

    return (
        <div className={styles.container}>
            <TitleText
                title={props.title}
                titleHighlightedWords={props.titleHighlightedWords}
                subtitle={props.subtitle}
                alignment="center"
                width="100%"
            />
            <div className={styles.tabsWrapper}>
                <TabList
                    selectedValue={selectedTab}
                    onTabSelect={(_, data) => setSelectedTab(data.value as string)}
                >
                    {props.tabs.map((tab, index) => (
                        <Tab key={index} value={`tab-${index}`}>
                            {tab.label}
                        </Tab>
                    ))}
                </TabList>
                {activeTab && (
                    <Text block className={styles.tabContent}>
                        {activeTab.content}
                    </Text>
                )}
            </div>
        </div>
    );
}
